/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import SignInFormComponent from 'components/forms/SignInForm';
import { getToken } from 'selectors/tokenSelectors';

const mapStateToProps = state => ({
  token: getToken(state),
  errorMessage: state.token.errorMessage,
});

const SignInFormContainer = connect(mapStateToProps)(SignInFormComponent);

export default SignInFormContainer;
